'use client';

import { getClassNames } from '@websolutespa/bom-core';
import { AnimatePresence } from 'motion/react';
import { forwardRef } from 'react';
import { useLlm } from '../../../useLlm/useLlm';
import { CanvasOffscreenProvider } from '../CanvasOffscreen/canvas-offscreen';

export type RootProps = {
  mode: string;
  opened?: boolean;
  embedded?: boolean;
  customIntro?: boolean;
  shouldShowTrigger?: boolean;
};

export const Root = forwardRef<HTMLDivElement, RootProps>(
  function Root({
    opened,
    embedded,
    customIntro,
    shouldShowTrigger,
    mode,
  }, ref) {
    const {
      Main,
      Font,
      Trigger,
    } = useLlm(state => state.components);

    const classNames = getClassNames('llm', 'llm__root', 'llm__reset', {
      '-open': opened,
      '-embedded': embedded,
      '-custom-intro': customIntro,
      ['-' + mode]: true,
    });

    return (
      <section
        ref={ref}
        className={classNames}
        data-opened={opened}
        data-embedded={embedded}
        data-custom-intro={customIntro}
        data-mode={mode}
      >
        <CanvasOffscreenProvider>
          <Font />
          <AnimatePresence mode="wait" initial={false}>
            {opened && (
              <Main key="main" />
            )}
          </AnimatePresence>
          <AnimatePresence mode="wait" initial={false}>
            {shouldShowTrigger && (
              <Trigger key="trigger" />
            )}
          </AnimatePresence>
        </CanvasOffscreenProvider>
      </section>
    );
  }
);
